// extracted by mini-css-extract-plugin
module.exports = {"cart":"BasketDesktop-module__cart___Rpp9n","cartItems":"BasketDesktop-module__cartItems___1guxU","highlightedVouchers":"BasketDesktop-module__highlightedVouchers___1yinQ"};